export function updateMainMenu(state, mainMenu) {
  state.mainMenu = mainMenu;
}
export function updateFavMenu(state, favouriteMenu) {
  state.favouriteMenu = favouriteMenu
    .sort((a, b) => a.id - b.id)
    .map((i) => {
      return { ...i, favourite: true };
    });
}
export function updateGeneralMenu(state, generalMenu) {
  state.generalMenu = generalMenu
    .sort((a, b) => a.id - b.id)
    .filter((i) => i.name != "Dashboard")
    .map((i) => {
      return {
        ...i,
        favourite:
          state.favouriteMenu.findIndex((fav) => i.text == fav.text) !== -1,
      };
    });
}
export function updateFavMenuWithId(state, updated) {
  const index = state.generalMenu.findIndex(
    (item) => item.text === updated.text
  );
  if (index !== -1) {
    state.generalMenu.splice(index, 1, updated);
  } else {
    state.generalMenu.push(updated);
  }
  state.generalMenu.sort((a, b) => a.id - b.id);
}
